import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { SectionContainer } from "../../../Utils/SectionContainer";
import { defaultStyles } from "./defaultStyles";

export interface HeroBlock5Props extends ComponentPropsWithRef<"table"> {
  headerContent?: ReactNode;
  primaryButton?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HeroBlock5 = forwardRef<HTMLTableElement, HeroBlock5Props>(
  ({ headerContent, primaryButton, styles = {}, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
        ignoreDefaults: false,
      },
    );

    return (
      <SectionContainer cssProperties={marginStyles}>
        <Section
          ref={ref}
          style={{
            ...backgroundStyles,
            ...paddingStyles,
          }}
          {...rest}
        >
          <Row>
            <Column>{headerContent}</Column>
          </Row>

          <Row>
            <Column>
              <BlockSection.NestedBlock>
                {primaryButton}
              </BlockSection.NestedBlock>
            </Column>
          </Row>
        </Section>
      </SectionContainer>
    );
  },
);

HeroBlock5.displayName = "HeroBlock5";
